var pre = '/market/';
export default {
  path: '/market',
  title: '市场管理',
  header: 'home',
  icon: 'md-cart',
  auth: ['market-manage'],
  children: [{
    path: "".concat(pre, "stall"),
    icon: 'ios-basket',
    title: '一铺一档',
    auth: ['market-manage-stall']
  }, {
    path: "".concat(pre, "approve"),
    icon: 'ios-create',
    title: '信息审核',
    subtitle: '入驻修改审核',
    auth: ['market-manage-approve']
  }, {
    path: "".concat(pre, "renewal"),
    icon: 'md-checkmark-circle-outline',
    title: '续租审核',
    subtitle: '续租申请管理',
    auth: ['market-manage-renewal']
  }, {
    path: "".concat(pre, "term-manage"),
    icon: 'md-calendar',
    title: '租期管理',
    subtitle: '租期与物业期管理',
    auth: ['market-manage-term']
  }, {
    path: "".concat(pre, "sign-up"),
    icon: 'ios-contacts',
    title: '报名管理',
    auth: ['market-manage-sign-up']
  }, {
    path: "".concat(pre, "valid"),
    icon: 'md-person-add',
    title: '入驻校验人员',
    auth: ['settle-in-valid']
  }, {
    path: "".concat(pre, "paid-bill"),
    icon: 'logo-buffer',
    title: '支付账单',
    auth: ['paid-bill']
  }, {
    path: "".concat(pre, "repair-order"),
    icon: 'ios-build',
    title: '物业报修',
    auth: ['repair-order']
  }, {
    path: "".concat(pre, "market-property-inspection"),
    icon: 'md-checkmark-circle-outline',
    title: '验房管理',
    auth: ['market-property-inspection']
  }, {
    path: "".concat(pre, "unpaid-bill"),
    icon: 'ios-cash',
    title: '待支付账单',
    auth: ['unpaid-bill']
  }, {
    path: "".concat(pre, "early-warning"),
    icon: 'ios-warning',
    title: '预警管理',
    auth: ['early-warning']
  }]
};